import { RootState } from "../root/redux.types";

export const selectNotifications = (state: RootState) => state.notifications;
